// Points formula, straight from the design source: minutes × difficulty scaled
// down by 5 and rounded, floored at 1 so even a trivial chore counts for something.
export const ptsFor = (minutes, difficulty) =>
  Math.max(1, Math.round(((minutes || 0) * (difficulty || 0)) / 5));
